import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TxService } from '../shared/tx.service';
import { HelperService } from '../helper/helper.service';
import { AccountService } from '../user/account.service';
import { tap } from 'rxjs/operators';
import { ApiErrorService } from '../api-error.service';
import { HotelSearchRequest } from 'src/app/models/hotel-booking/search-request';
import { DatePipe } from '@angular/common';
import { PaymentIntentResponse } from 'src/app/models/payment';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { Location, PlatformLocation } from '@angular/common';
import { localStorageKeys } from '../localStorage/localStorageVariables';

@Injectable({
  providedIn: 'root',
})
export class BusBookingService {
  apiParams: any;
  private bookingReviewData: any | null = null;

  constructor(
    private httpClient: SmartHttpService,
    private envService: TxService,
    private helperService: HelperService,
    private localStorageData: LocalStorageService
  ) {
    this.initApiParams();
  }

  public get busSearchQuery(): string {
    return this.localStorageData.getItem(localStorageKeys.BUS_SEARCH_QUERY);
  }

  public set resentSearches(value: string) {
    this.localStorageData.setItem(localStorageKeys.RECENT_SEARCHES, value);
  }

  public get resentSearches(): string {
    return this.localStorageData.getItem(localStorageKeys.RECENT_SEARCHES);
  }

  public set busSearchQuery(value: string) {
    this.localStorageData.setItem(localStorageKeys.BUS_SEARCH_QUERY, value);
  }

  public get busBookingSearchApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    console.log('busBookingSearchApi called', finalRequestParams);
    return `${this.envService.getBusBookingSearchApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busBookingAvailabilityApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingAvailabilityApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busSeatArrangementApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusSeatArrangementApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get getBusBookingBookSeatApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingBookSeatApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get getBusBookingBlockSeatApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingBlockSeatApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busBookingDetailsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingDetailsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busBookingFetchBookingStatusApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingFetchBookingStatusApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busBookingHistoryApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingHistoryApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busCancellationDetailsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusCancellationDetailsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get confirmBusCancellationApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getConfirmBusCancellationApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busRouteSequenceApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusRouteSequenceApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busCancellationPoliciesApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusCancellationPoliciesApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get busBookingReviewApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getBusBookingReviewApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public get addUserActionApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.addUserActionApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public set busBookingSearchApi(value: string) {}
  public set busBookingAvailabilityApi(value: string) {}
  public set busSeatArrangementApi(value: string) {}
  public set getBusBookingBookSeatApi(value: string) {}
  public set getBusBookingBlockSeatApi(value: string) {}
  public set busBookingDetailsApi(value: string) {}
  public set busBookingFetchBookingStatusApi(value: string) {}
  public set busBookingHistoryApi(value: string) {}
  public set busCancellationDetailsApi(value: string) {}
  public set confirmBusCancellationApi(value: string) {}
  public set busRouteSequenceApi(value: string) {}
  public set busCancellationPoliciesApi(value: string) {}
  public set busBookingReviewApi(value: string) {}
  public set addUserActionApi(value: string) {}

  initApiParams() {
    this.apiParams = {};
  }

  // Temporary in-memory storage for booking review data until API is ready
  public setBookingReviewData(data: any): void {
    this.bookingReviewData = data;
  }

  public getBookingReviewData(): any | null {
    return this.bookingReviewData;
  }

  searchBuses(
    searchTerm?: string,
    page?: number,
    count?: number
  ): Observable<any> {
    console.log('searchBuses called with ', searchTerm, page, count);
    this.initApiParams();
    this.apiParams.q = searchTerm?.trim() || '';
    this.apiParams.page = page || 0;
    this.apiParams.size = count || 10;

    return this.httpClient.get(this.busBookingSearchApi);
  }

  getBusAvailability(
    availabilityParams: any,
    pid: string,
    lang: string,
    currency: string,
    sort?: string,
    page?: number,
    size?: number
  ): Observable<any> {
    this.initApiParams();
    const payload = {
      source: availabilityParams?.sourceEntityId,
      destination: availabilityParams?.destinationEntityId,
      travelDate: availabilityParams?.departureDate,
      pid: pid,
      currency: currency,
      language: lang,
      fq: availabilityParams?.fq || [],
      rt: null,
    };

    if (sort) {
      this.apiParams.sort = sort;
    }
    if (page !== undefined) {
      this.apiParams.page = page || 0;
    }
    if (size !== undefined) {
      this.apiParams.size = size || 5;
    }

    return this.httpClient.postWithErorrHandler(
      this.busBookingAvailabilityApi,
      payload
    );
  }

  getBusSeatArrangement(resultId: string): Observable<any> {
    this.initApiParams();
    const payload = {
      resultId: resultId,
    };
    return this.httpClient.postWithErorrHandler(
      this.busSeatArrangementApi,
      payload
    );
  }

  blockBusSeat(payload: any, campaignId: any): Observable<any> {
    this.initApiParams();
    this.apiParams.campaignId = campaignId;
    return this.httpClient.postWithErorrHandler(
      this.getBusBookingBlockSeatApi,
      payload
    );
  }

  bookBusSeat(payload: any, bookingId: any, campaignId: any): Observable<any> {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    this.apiParams.campaignId = campaignId;
    return this.httpClient.postWithErorrHandler(
      this.getBusBookingBookSeatApi,
      payload
    );
  }

  getBusBookingDetails(bookingId: string): Observable<any> {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    return this.httpClient.get(this.busBookingDetailsApi);
  }

  getfetchBusBookingStatus(bookingId: string): Observable<any> {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    return this.httpClient.get(this.busBookingFetchBookingStatusApi);
  }

  getBusBookingHistory(page: number, count: number): Observable<any> {
    this.initApiParams();
    this.apiParams.page = page;
    this.apiParams.count = count;
    return this.httpClient.get(this.busBookingHistoryApi);
  }

  getBusCancellationDetails(payload: any): Observable<any> {
    this.initApiParams();
    return this.httpClient.postWithErorrHandler(
      this.busCancellationDetailsApi,
      payload
    );
  }

  getConfirmBusCancellation(bookingId: any, payload: any): Observable<any> {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    return this.httpClient.postWithErorrHandler(
      this.confirmBusCancellationApi,
      payload
    );
  }

  getBusRouteSequence(payload: any): Observable<any> {
    this.initApiParams();
    return this.httpClient.postWithErorrHandler(
      this.busRouteSequenceApi,
      payload
    );
  }

  getBusCancellationPolicies(payload: any): Observable<any> {
    this.initApiParams();
    return this.httpClient.postWithErorrHandler(
      this.busCancellationPoliciesApi,
      payload
    );
  }

  getBusBookingReview(payload: any): Observable<any> {
    this.initApiParams();
    return this.httpClient.postWithErorrHandler(
      this.busBookingReviewApi,
      payload
    );
  }

  resendEmailAction(bookingId: any): Observable<any> {
    this.initApiParams();
    this.apiParams.action_name = 'booking_confirm';
    this.apiParams.action_type = 'bus_booking';
    this.apiParams.action_id = bookingId;
    return this.httpClient.postWithErorrHandler(this.addUserActionApi, {});
  }
}
